import { X } from 'lucide-react';

import { formatDateRange, formatHours } from './helpers';
import type { PlanExtraRowProps } from './types';

// Extra hours already given: why and when, their hours under their bucket.
export function PlanExtraRow({ extra, clientName, onRemove }: PlanExtraRowProps) {
  const reason = extra.notes || 'Extra hours';
  const hours = (bucket: 'fixed' | 'variable') => (
    <span className="pr-8 text-right text-sm tabular-nums text-text-secondary">
      {extra.bucket === bucket ? (
        formatHours(extra.hours)
      ) : (
        <span className="text-text-tertiary">—</span>
      )}
    </span>
  );

  return (
    <div data-testid="plan-extra" className="contents">
      <span className="truncate text-sm text-text-primary">
        {reason}
        <span className="text-text-tertiary">
          {' '}
          · {formatDateRange(extra.startDate, extra.endDate)}
        </span>
      </span>
      {hours('fixed')}
      {hours('variable')}
      <button
        type="button"
        aria-label={`Remove ${reason} from ${clientName}`}
        onClick={onRemove}
        className="justify-self-center rounded-8 p-1 text-text-tertiary transition-colors hover:bg-foreground/[0.06] hover:text-text-primary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus"
      >
        <X className="size-3.5" />
      </button>
    </div>
  );
}
